import './NotificationsList.scss';

import { bem } from 'mission-control-common-components';
import InfiniteScroll from 'react-infinite-scroll-component';

import Loader from '../../Loader';
import NotificationsLogListEntry from '../NotificationsLogListEntry/NotificationsLogListEntry';
import type { ChangeLogListProps } from '../types';

const [block, element] = bem('notifiation-change-log-list');

const NotificationsList = ({
  toggles,
  toggleAt,
  loading,
  initialLoading,
  filteredLogsToShow,
  hasMore,
  onNext,
  toggleCheckedAt,
  checkedIds,
}: ChangeLogListProps): JSX.Element => {
  if (initialLoading) {
    return (
      <div className={element('loader-wrapper')}>
        <Loader text="Loading..." />
      </div>
    );
  }

  if (!loading && !initialLoading && !filteredLogsToShow?.length) {
    return <p className={element('no-changes')}>No changes.</p>;
  }
  return (
    <section data-testid="change-log-list" id="scrollableDiv" className={block()}>
      <InfiniteScroll
        scrollableTarget="scrollableDiv"
        dataLength={filteredLogsToShow?.length || 0}
        next={onNext || (() => {})}
        hasMore={hasMore || false}
        loader={<></>}
        height={350}
      >
        {filteredLogsToShow?.map(
          (filteredChangeLogEntry, index): JSX.Element => {
            return (
              <NotificationsLogListEntry
                {...filteredChangeLogEntry}
                toggles={toggles}
                toggleAt={toggleAt}
                checkedIds={checkedIds}
                toggleCheckedAt={toggleCheckedAt}
                originalIndex={filteredChangeLogEntry.originalIndex}
                key={`change-log-list-${filteredChangeLogEntry.id}-${index}`}
              />
            );
          }
        )}
      </InfiniteScroll>
      {loading && <div className={element('scroll-loader')}>{<Loader />}</div>}
    </section>
  );
};

export default NotificationsList;
